import { useMemo } from 'react';
import { Modal } from '../../components/Modal';
import { ModalTotalFooter } from '../../components/ModalTotalFooter';
import { OptionRow } from '../../components/OptionRow';
import { formatCurrency } from '../../utils/formatCurrency';
import { GuestList } from './GuestSelectModal.styles';
import type { GuestSelectModalProps } from './GuestSelectModal.types';

export function GuestSelectModal({
  open,
  onClose,
  guests,
  onToggleGuest,
  onConfirm,
  extraTitle,
  currencyCode = 'GBP',
  locale = 'en-GB',
  labels = {},
}: GuestSelectModalProps) {
  const { title = 'Select guests', close = 'Close', total = 'Total', confirm = 'Confirm' } = labels;

  const totalAmount = useMemo(
    () => guests.filter((g) => g.selected).reduce((sum, g) => sum + g.price.amount, 0),
    [guests]
  );

  const footer = (
    <ModalTotalFooter
      title={extraTitle}
      totalLabel={total}
      totalAmount={totalAmount}
      currencyCode={currencyCode}
      locale={locale}
      confirmLabel={confirm}
      onConfirm={onConfirm}
    />
  );

  return (
    <Modal open={open} onClose={onClose} title={title} footer={footer} labels={{ close }}>
      <GuestList>
        {guests.map((guest) => (
          <OptionRow
            key={guest.id}
            label={guest.label}
            sublabel={`+ ${formatCurrency(guest.price.amount, guest.price.currencyCode, {
              locale,
            })}`}
            selected={guest.selected}
            onClick={() => onToggleGuest(guest.id)}
          />
        ))}
      </GuestList>
    </Modal>
  );
}
